import { httpV2 } from "../http";

const TagGroupsService = {
  list: () => httpV2.get("/tag-groups"),
  create: (label) => httpV2.post("/tag-groups", { label }),
  rename: (id, label) => httpV2.put(`/tag-groups/${id}`, { label }),
  remove: (id) => httpV2.delete(`/tag-groups/${id}`),
  addTag: (groupId, tagId) =>
    httpV2.post(`/tag-groups/${groupId}/tags/${tagId}`),
  removeTag: (groupId, tagId) =>
    httpV2.delete(`/tag-groups/${groupId}/tags/${tagId}`),
};

export default TagGroupsService;
